import { render, staticRenderFns } from "./direccion-envio.vue?vue&type=template&id=b44170b6&"
import script from "./direccion-envio.vue?vue&type=script&lang=js&"
export * from "./direccion-envio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports